module.exports = __webpack_public_path__ + "static/media/ITTTech.f2b58e5b.svg";